import e, { useState as t, useEffect as n, useRef as o } from "react";
function r(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function a(e, t, n, o, r, a, i) {
  try {
    var l = e[a](i),
      s = l.value;
  } catch (e) {
    return void n(e);
  }
  l.done ? t(s) : Promise.resolve(s).then(o, r);
}
function i(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (o, r) {
      var i = e.apply(t, n);
      function l(e) {
        a(i, o, r, l, s, "next", e);
      }
      function s(e) {
        a(i, o, r, l, s, "throw", e);
      }
      l(void 0);
    });
  };
}
function l(e, t, n) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var o = n.call(e, t || "default");
        if ("object" != typeof o) return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function s(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function c(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? s(Object(n), !0).forEach(function (t) {
      l(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function u() {
  u = function u() {
    return t;
  };
  var e,
    t = {},
    n = Object.prototype,
    o = n.hasOwnProperty,
    r = Object.defineProperty || function (e, t, n) {
      e[t] = n.value;
    },
    a = "function" == typeof Symbol ? Symbol : {},
    i = a.iterator || "@@iterator",
    l = a.asyncIterator || "@@asyncIterator",
    s = a.toStringTag || "@@toStringTag";
  function c(e, t, n) {
    return Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    c({}, "");
  } catch (e) {
    c = function c(e, t, n) {
      return e[t] = n;
    };
  }
  function d(e, t, n, o) {
    var a = t && t.prototype instanceof v ? t : v,
      i = Object.create(a.prototype),
      l = new S(o || []);
    return r(i, "_invoke", {
      value: E(e, n, l)
    }), i;
  }
  function _(e, t, n) {
    try {
      return {
        type: "normal",
        arg: e.call(t, n)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  t.wrap = d;
  var m = "suspendedStart",
    f = "suspendedYield",
    p = "executing",
    b = "completed",
    h = {};
  function v() {}
  function g() {}
  function y() {}
  var x = {};
  c(x, i, function () {
    return this;
  });
  var w = Object.getPrototypeOf,
    M = w && w(w(N([])));
  M && M !== n && o.call(M, i) && (x = M);
  var T = y.prototype = v.prototype = Object.create(x);
  function k(e) {
    ["next", "throw", "return"].forEach(function (t) {
      c(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function F(e, t) {
    function n(r, a, i, l) {
      var s = _(e[r], e, a);
      if ("throw" !== s.type) {
        var c = s.arg,
          u = c.value;
        return u && "object" == typeof u && o.call(u, "__await") ? t.resolve(u.__await).then(function (e) {
          n("next", e, i, l);
        }, function (e) {
          n("throw", e, i, l);
        }) : t.resolve(u).then(function (e) {
          c.value = e, i(c);
        }, function (e) {
          return n("throw", e, i, l);
        });
      }
      l(s.arg);
    }
    var a;
    r(this, "_invoke", {
      value: function value(e, o) {
        function r() {
          return new t(function (t, r) {
            n(e, o, t, r);
          });
        }
        return a = a ? a.then(r, r) : r();
      }
    });
  }
  function E(t, n, o) {
    var r = m;
    return function (a, i) {
      if (r === p) throw Error("Generator is already running");
      if (r === b) {
        if ("throw" === a) throw i;
        return {
          value: e,
          done: !0
        };
      }
      for (o.method = a, o.arg = i;;) {
        var l = o.delegate;
        if (l) {
          var s = C(l, o);
          if (s) {
            if (s === h) continue;
            return s;
          }
        }
        if ("next" === o.method) o.sent = o._sent = o.arg;else if ("throw" === o.method) {
          if (r === m) throw r = b, o.arg;
          o.dispatchException(o.arg);
        } else "return" === o.method && o.abrupt("return", o.arg);
        r = p;
        var c = _(t, n, o);
        if ("normal" === c.type) {
          if (r = o.done ? b : f, c.arg === h) continue;
          return {
            value: c.arg,
            done: o.done
          };
        }
        "throw" === c.type && (r = b, o.method = "throw", o.arg = c.arg);
      }
    };
  }
  function C(t, n) {
    var o = n.method,
      r = t.iterator[o];
    if (r === e) return n.delegate = null, "throw" === o && t.iterator.return && (n.method = "return", n.arg = e, C(t, n), "throw" === n.method) || "return" !== o && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + o + "' method")), h;
    var a = _(r, t.iterator, n.arg);
    if ("throw" === a.type) return n.method = "throw", n.arg = a.arg, n.delegate = null, h;
    var i = a.arg;
    return i ? i.done ? (n[t.resultName] = i.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, h) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, h);
  }
  function L(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function j(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function S(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(L, this), this.reset(!0);
  }
  function N(t) {
    if (t || "" === t) {
      var n = t[i];
      if (n) return n.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var r = -1,
          a = function n() {
            for (; ++r < t.length;) if (o.call(t, r)) return n.value = t[r], n.done = !1, n;
            return n.value = e, n.done = !0, n;
          };
        return a.next = a;
      }
    }
    throw new TypeError(typeof t + " is not iterable");
  }
  return g.prototype = y, r(T, "constructor", {
    value: y,
    configurable: !0
  }), r(y, "constructor", {
    value: g,
    configurable: !0
  }), g.displayName = c(y, s, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
  }, t.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, c(e, s, "GeneratorFunction")), e.prototype = Object.create(T), e;
  }, t.awrap = function (e) {
    return {
      __await: e
    };
  }, k(F.prototype), c(F.prototype, l, function () {
    return this;
  }), t.AsyncIterator = F, t.async = function (e, n, o, r, a) {
    void 0 === a && (a = Promise);
    var i = new F(d(e, n, o, r), a);
    return t.isGeneratorFunction(n) ? i : i.next().then(function (e) {
      return e.done ? e.value : i.next();
    });
  }, k(T), c(T, s, "Generator"), c(T, i, function () {
    return this;
  }), c(T, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (e) {
    var t = Object(e),
      n = [];
    for (var o in t) n.push(o);
    return n.reverse(), function e() {
      for (; n.length;) {
        var o = n.pop();
        if (o in t) return e.value = o, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, t.values = N, S.prototype = {
    constructor: S,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(j), !t) for (var n in this) "t" === n.charAt(0) && o.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var n = this;
      function r(o, r) {
        return l.type = "throw", l.arg = t, n.next = o, r && (n.method = "next", n.arg = e), !!r;
      }
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var i = this.tryEntries[a],
          l = i.completion;
        if ("root" === i.tryLoc) return r("end");
        if (i.tryLoc <= this.prev) {
          var s = o.call(i, "catchLoc"),
            c = o.call(i, "finallyLoc");
          if (s && c) {
            if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return r(i.finallyLoc);
          } else if (s) {
            if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
          } else {
            if (!c) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return r(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var r = this.tryEntries[n];
        if (r.tryLoc <= this.prev && o.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
          var a = r;
          break;
        }
      }
      a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
      var i = a ? a.completion : {};
      return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, h) : this.complete(i);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), j(n), h;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.tryLoc === e) {
          var o = n.completion;
          if ("throw" === o.type) {
            var r = o.arg;
            j(n);
          }
          return r;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, n, o) {
      return this.delegate = {
        iterator: N(t),
        resultName: n,
        nextLoc: o
      }, "next" === this.method && (this.arg = e), h;
    }
  }, t;
}
function d(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var o,
        r,
        a,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (a = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          s = !1;
        } else for (; !(s = (o = a.call(n)).done) && (l.push(o.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, r = e;
      } finally {
        try {
          if (!s && null != n.return && (i = n.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw r;
        }
      }
      return l;
    }
  }(e, t) || m(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function _(e) {
  return function (e) {
    if (Array.isArray(e)) return r(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || m(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function m(e, t) {
  if (e) {
    if ("string" == typeof e) return r(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
  }
}
function f(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var p,
  b = {
    exports: {}
  },
  h = {
    exports: {}
  },
  v = {};
var g,
  y,
  x,
  w,
  M,
  T,
  k,
  F,
  E,
  C,
  L,
  j,
  S,
  N,
  O = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function P() {
  return y || (y = 1, "production" === process.env.NODE_ENV ? h.exports = function () {
    if (p) return v;
    p = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      o = e ? Symbol.for("react.fragment") : 60107,
      r = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      s = e ? Symbol.for("react.async_mode") : 60111,
      c = e ? Symbol.for("react.concurrent_mode") : 60111,
      u = e ? Symbol.for("react.forward_ref") : 60112,
      d = e ? Symbol.for("react.suspense") : 60113,
      _ = e ? Symbol.for("react.suspense_list") : 60120,
      m = e ? Symbol.for("react.memo") : 60115,
      f = e ? Symbol.for("react.lazy") : 60116,
      b = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      y = e ? Symbol.for("react.scope") : 60119;
    function x(e) {
      if ("object" == typeof e && null !== e) {
        var _ = e.$$typeof;
        switch (_) {
          case t:
            switch (e = e.type) {
              case s:
              case c:
              case o:
              case a:
              case r:
              case d:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case u:
                  case f:
                  case m:
                  case i:
                    return e;
                  default:
                    return _;
                }
            }
          case n:
            return _;
        }
      }
    }
    function w(e) {
      return x(e) === c;
    }
    return v.AsyncMode = s, v.ConcurrentMode = c, v.ContextConsumer = l, v.ContextProvider = i, v.Element = t, v.ForwardRef = u, v.Fragment = o, v.Lazy = f, v.Memo = m, v.Portal = n, v.Profiler = a, v.StrictMode = r, v.Suspense = d, v.isAsyncMode = function (e) {
      return w(e) || x(e) === s;
    }, v.isConcurrentMode = w, v.isContextConsumer = function (e) {
      return x(e) === l;
    }, v.isContextProvider = function (e) {
      return x(e) === i;
    }, v.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, v.isForwardRef = function (e) {
      return x(e) === u;
    }, v.isFragment = function (e) {
      return x(e) === o;
    }, v.isLazy = function (e) {
      return x(e) === f;
    }, v.isMemo = function (e) {
      return x(e) === m;
    }, v.isPortal = function (e) {
      return x(e) === n;
    }, v.isProfiler = function (e) {
      return x(e) === a;
    }, v.isStrictMode = function (e) {
      return x(e) === r;
    }, v.isSuspense = function (e) {
      return x(e) === d;
    }, v.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === c || e === a || e === r || e === d || e === _ || "object" == typeof e && null !== e && (e.$$typeof === f || e.$$typeof === m || e.$$typeof === i || e.$$typeof === l || e.$$typeof === u || e.$$typeof === h || e.$$typeof === g || e.$$typeof === y || e.$$typeof === b);
    }, v.typeOf = x, v;
  }() : h.exports = (g || (g = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      o = e ? Symbol.for("react.fragment") : 60107,
      r = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      s = e ? Symbol.for("react.async_mode") : 60111,
      c = e ? Symbol.for("react.concurrent_mode") : 60111,
      u = e ? Symbol.for("react.forward_ref") : 60112,
      d = e ? Symbol.for("react.suspense") : 60113,
      _ = e ? Symbol.for("react.suspense_list") : 60120,
      m = e ? Symbol.for("react.memo") : 60115,
      f = e ? Symbol.for("react.lazy") : 60116,
      p = e ? Symbol.for("react.block") : 60121,
      b = e ? Symbol.for("react.fundamental") : 60117,
      h = e ? Symbol.for("react.responder") : 60118,
      v = e ? Symbol.for("react.scope") : 60119;
    function g(e) {
      if ("object" == typeof e && null !== e) {
        var _ = e.$$typeof;
        switch (_) {
          case t:
            var p = e.type;
            switch (p) {
              case s:
              case c:
              case o:
              case a:
              case r:
              case d:
                return p;
              default:
                var b = p && p.$$typeof;
                switch (b) {
                  case l:
                  case u:
                  case f:
                  case m:
                  case i:
                    return b;
                  default:
                    return _;
                }
            }
          case n:
            return _;
        }
      }
    }
    var y = s,
      x = c,
      w = l,
      M = i,
      T = t,
      k = u,
      F = o,
      E = f,
      C = m,
      L = n,
      j = a,
      S = r,
      N = d,
      P = !1;
    function A(e) {
      return g(e) === c;
    }
    O.AsyncMode = y, O.ConcurrentMode = x, O.ContextConsumer = w, O.ContextProvider = M, O.Element = T, O.ForwardRef = k, O.Fragment = F, O.Lazy = E, O.Memo = C, O.Portal = L, O.Profiler = j, O.StrictMode = S, O.Suspense = N, O.isAsyncMode = function (e) {
      return P || (P = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(e) || g(e) === s;
    }, O.isConcurrentMode = A, O.isContextConsumer = function (e) {
      return g(e) === l;
    }, O.isContextProvider = function (e) {
      return g(e) === i;
    }, O.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, O.isForwardRef = function (e) {
      return g(e) === u;
    }, O.isFragment = function (e) {
      return g(e) === o;
    }, O.isLazy = function (e) {
      return g(e) === f;
    }, O.isMemo = function (e) {
      return g(e) === m;
    }, O.isPortal = function (e) {
      return g(e) === n;
    }, O.isProfiler = function (e) {
      return g(e) === a;
    }, O.isStrictMode = function (e) {
      return g(e) === r;
    }, O.isSuspense = function (e) {
      return g(e) === d;
    }, O.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === c || e === a || e === r || e === d || e === _ || "object" == typeof e && null !== e && (e.$$typeof === f || e.$$typeof === m || e.$$typeof === i || e.$$typeof === l || e.$$typeof === u || e.$$typeof === b || e.$$typeof === h || e.$$typeof === v || e.$$typeof === p);
    }, O.typeOf = g;
  }()), O)), h.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function A() {
  if (w) return x;
  w = 1;
  var e = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable;
  return x = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        o[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (o, r) {
    for (var a, i, l = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(o), s = 1; s < arguments.length; s++) {
      for (var c in a = Object(arguments[s])) t.call(a, c) && (l[c] = a[c]);
      if (e) {
        i = e(a);
        for (var u = 0; u < i.length; u++) n.call(a, i[u]) && (l[i[u]] = a[i[u]]);
      }
    }
    return l;
  }, x;
}
function z() {
  if (T) return M;
  T = 1;
  return M = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function U() {
  return F ? k : (F = 1, k = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var I = P();
  b.exports = function () {
    if (j) return L;
    j = 1;
    var e = P(),
      t = A(),
      n = z(),
      o = U(),
      r = function () {
        if (C) return E;
        C = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var t = z(),
            n = {},
            o = U();
          e = function e(_e2) {
            var t = "Warning: " + _e2;
            "undefined" != typeof console && console.error(t);
            try {
              throw new Error(t);
            } catch (e) {}
          };
        }
        function r(r, a, i, l, s) {
          if ("production" !== process.env.NODE_ENV) for (var c in r) if (o(r, c)) {
            var u;
            try {
              if ("function" != typeof r[c]) {
                var d = Error((l || "React class") + ": " + i + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw d.name = "Invariant Violation", d;
              }
              u = r[c](a, c, l, i, null, t);
            } catch (e) {
              u = e;
            }
            if (!u || u instanceof Error || e((l || "React class") + ": type specification of " + i + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in n)) {
              n[u.message] = !0;
              var _ = s ? s() : "";
              e("Failed " + i + " type: " + u.message + (null != _ ? _ : ""));
            }
          }
        }
        return r.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (n = {});
        }, E = r;
      }(),
      a = function a() {};
    function i() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (a = function a(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);
      try {
        throw new Error(t);
      } catch (e) {}
    }), L = function L(l, s) {
      var c = "function" == typeof Symbol && Symbol.iterator,
        u = "<<anonymous>>",
        d = {
          array: p("array"),
          bigint: p("bigint"),
          bool: p("boolean"),
          func: p("function"),
          number: p("number"),
          object: p("object"),
          string: p("string"),
          symbol: p("symbol"),
          any: f(i),
          arrayOf: function arrayOf(e) {
            return f(function (t, o, r, a, i) {
              if ("function" != typeof e) return new m("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
              var l = t[o];
              if (!Array.isArray(l)) return new m("Invalid " + a + " `" + i + "` of type `" + v(l) + "` supplied to `" + r + "`, expected an array.");
              for (var s = 0; s < l.length; s++) {
                var c = e(l, s, r, a, i + "[" + s + "]", n);
                if (c instanceof Error) return c;
              }
              return null;
            });
          },
          element: f(function (e, t, n, o, r) {
            var a = e[t];
            return l(a) ? null : new m("Invalid " + o + " `" + r + "` of type `" + v(a) + "` supplied to `" + n + "`, expected a single ReactElement.");
          }),
          elementType: f(function (t, n, o, r, a) {
            var i = t[n];
            return e.isValidElementType(i) ? null : new m("Invalid " + r + " `" + a + "` of type `" + v(i) + "` supplied to `" + o + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return f(function (t, n, o, r, a) {
              if (!(t[n] instanceof e)) {
                var i = e.name || u;
                return new m("Invalid " + r + " `" + a + "` of type `" + ((l = t[n]).constructor && l.constructor.name ? l.constructor.name : u) + "` supplied to `" + o + "`, expected instance of `" + i + "`.");
              }
              var l;
              return null;
            });
          },
          node: f(function (e, t, n, o, r) {
            return h(e[t]) ? null : new m("Invalid " + o + " `" + r + "` supplied to `" + n + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return f(function (t, r, a, i, l) {
              if ("function" != typeof e) return new m("Property `" + l + "` of component `" + a + "` has invalid PropType notation inside objectOf.");
              var s = t[r],
                c = v(s);
              if ("object" !== c) return new m("Invalid " + i + " `" + l + "` of type `" + c + "` supplied to `" + a + "`, expected an object.");
              for (var u in s) if (o(s, u)) {
                var d = e(s, u, a, i, l + "." + u, n);
                if (d instanceof Error) return d;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? f(function (t, n, o, r, a) {
              for (var i = t[n], l = 0; l < e.length; l++) if (_(i, e[l])) return null;
              var s = JSON.stringify(e, function (e, t) {
                return "symbol" === g(t) ? String(t) : t;
              });
              return new m("Invalid " + r + " `" + a + "` of value `" + String(i) + "` supplied to `" + o + "`, expected one of " + s + ".");
            }) : ("production" !== process.env.NODE_ENV && a(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
            for (var t = 0; t < e.length; t++) {
              var r = e[t];
              if ("function" != typeof r) return a("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + y(r) + " at index " + t + "."), i;
            }
            return f(function (t, r, a, i, l) {
              for (var s = [], c = 0; c < e.length; c++) {
                var u = (0, e[c])(t, r, a, i, l, n);
                if (null == u) return null;
                u.data && o(u.data, "expectedType") && s.push(u.data.expectedType);
              }
              return new m("Invalid " + i + " `" + l + "` supplied to `" + a + "`" + (s.length > 0 ? ", expected one of type [" + s.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return f(function (t, o, r, a, i) {
              var l = t[o],
                s = v(l);
              if ("object" !== s) return new m("Invalid " + a + " `" + i + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");
              for (var c in e) {
                var u = e[c];
                if ("function" != typeof u) return b(r, a, i, c, g(u));
                var d = u(l, c, r, a, i + "." + c, n);
                if (d) return d;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return f(function (r, a, i, l, s) {
              var c = r[a],
                u = v(c);
              if ("object" !== u) return new m("Invalid " + l + " `" + s + "` of type `" + u + "` supplied to `" + i + "`, expected `object`.");
              var d = t({}, r[a], e);
              for (var _ in d) {
                var f = e[_];
                if (o(e, _) && "function" != typeof f) return b(i, l, s, _, g(f));
                if (!f) return new m("Invalid " + l + " `" + s + "` key `" + _ + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(r[a], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var p = f(c, _, i, l, s + "." + _, n);
                if (p) return p;
              }
              return null;
            });
          }
        };
      function _(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }
      function m(e, t) {
        this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
      }
      function f(e) {
        if ("production" !== process.env.NODE_ENV) var t = {},
          o = 0;
        function r(r, i, l, c, d, _, f) {
          if (c = c || u, _ = _ || l, f !== n) {
            if (s) {
              var p = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw p.name = "Invariant Violation", p;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var b = c + ":" + l;
              !t[b] && o < 3 && (a("You are manually calling a React.PropTypes validation function for the `" + _ + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), t[b] = !0, o++);
            }
          }
          return null == i[l] ? r ? null === i[l] ? new m("The " + d + " `" + _ + "` is marked as required in `" + c + "`, but its value is `null`.") : new m("The " + d + " `" + _ + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : e(i, l, c, d, _);
        }
        var i = r.bind(null, !1);
        return i.isRequired = r.bind(null, !0), i;
      }
      function p(e) {
        return f(function (t, n, o, r, a, i) {
          var l = t[n];
          return v(l) !== e ? new m("Invalid " + r + " `" + a + "` of type `" + g(l) + "` supplied to `" + o + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function b(e, t, n, o, r) {
        return new m((e || "React class") + ": " + t + " type `" + n + "." + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + r + "`.");
      }
      function h(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(h);
            if (null === e || l(e)) return !0;
            var t = function (e) {
              var t = e && (c && e[c] || e["@@iterator"]);
              if ("function" == typeof t) return t;
            }(e);
            if (!t) return !1;
            var n,
              o = t.call(e);
            if (t !== e.entries) {
              for (; !(n = o.next()).done;) if (!h(n.value)) return !1;
            } else for (; !(n = o.next()).done;) {
              var r = n.value;
              if (r && !h(r[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function v(e) {
        var t = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
          return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
        }(t, e) ? "symbol" : t;
      }
      function g(e) {
        if (null == e) return "" + e;
        var t = v(e);
        if ("object" === t) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return t;
      }
      function y(e) {
        var t = g(e);
        switch (t) {
          case "array":
          case "object":
            return "an " + t;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + t;
          default:
            return t;
        }
      }
      return m.prototype = Error.prototype, d.checkPropTypes = r, d.resetWarningCache = r.resetWarningCache, d.PropTypes = d, d;
    }, L;
  }()(I.isElement, !0);
} else b.exports = function () {
  if (N) return S;
  N = 1;
  var e = z();
  function t() {}
  function n() {}
  return n.resetWarningCache = t, S = function S() {
    function o(t, n, o, r, a, i) {
      if (i !== e) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }
    function r() {
      return o;
    }
    o.isRequired = o;
    var a = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: r,
      element: o,
      elementType: o,
      instanceOf: r,
      node: o,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  };
}()();
var R = f(b.exports);
function W(e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;
  if (e && "undefined" != typeof document) {
    var o = document.head || document.getElementsByTagName("head")[0],
      r = document.createElement("style");
    r.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
  }
}
var Y = {
  PersonalizationModal__backdrop: "FavourtiesModal-module_PersonalizationModal__backdrop__6vewn",
  enter: "FavourtiesModal-module_enter__h-XuO",
  will_hide: "FavourtiesModal-module_will_hide__2443H",
  exit: "FavourtiesModal-module_exit__I7YSm",
  PersonalizationModal__cont: "FavourtiesModal-module_PersonalizationModal__cont__E1Zbb",
  "phase-1": "FavourtiesModal-module_phase-1__-YS-t",
  flash1: "FavourtiesModal-module_flash1__O80rj",
  "phase-2": "FavourtiesModal-module_phase-2__n5xEl",
  flash2: "FavourtiesModal-module_flash2__4lPfG",
  "phase-3": "FavourtiesModal-module_phase-3__U6BfE",
  flash3: "FavourtiesModal-module_flash3__6x0Gs",
  close_icon__cont: "FavourtiesModal-module_close_icon__cont__3i0uN",
  title: "FavourtiesModal-module_title__FOzRB",
  header_text: "FavourtiesModal-module_header_text__MfEtH",
  search: "FavourtiesModal-module_search__joaMN",
  header__cont: "FavourtiesModal-module_header__cont__2xS60",
  tabs__cont: "FavourtiesModal-module_tabs__cont__oCwej",
  hidden: "FavourtiesModal-module_hidden__E0xdY",
  body__cont: "FavourtiesModal-module_body__cont__sJzBy",
  teams__cont: "FavourtiesModal-module_teams__cont__hbbZZ",
  teams_wrapper: "FavourtiesModal-module_teams_wrapper__ZwjK2",
  teams_heading: "FavourtiesModal-module_teams_heading__FvAP2",
  team__cont: "FavourtiesModal-module_team__cont__4DUWx",
  league__cont: "FavourtiesModal-module_league__cont__-BcJN",
  team_logo: "FavourtiesModal-module_team_logo__Ycf-7",
  team_name: "FavourtiesModal-module_team_name__52LhA",
  selected: "FavourtiesModal-module_selected__FCkp2",
  include_league: "FavourtiesModal-module_include_league__TgclW",
  team_league: "FavourtiesModal-module_team_league__u-Ues",
  location_instructions__cont: "FavourtiesModal-module_location_instructions__cont__7uuAP",
  location_instructions: "FavourtiesModal-module_location_instructions__--mYu",
  location_instructions_ext: "FavourtiesModal-module_location_instructions_ext__3C1yy",
  location_button: "FavourtiesModal-module_location_button__3ZwjT",
  footer__cont: "FavourtiesModal-module_footer__cont__5jf7t",
  clean_footer__cont: "FavourtiesModal-module_clean_footer__cont__xx-AR",
  footer_title: "FavourtiesModal-module_footer_title__KkCzw",
  footer_favorites__cont: "FavourtiesModal-module_footer_favorites__cont__uGUJn",
  selected_favorite: "FavourtiesModal-module_selected_favorite__QjcW6",
  none_selected: "FavourtiesModal-module_none_selected__LElLu",
  selected_favorites__cont: "FavourtiesModal-module_selected_favorites__cont__0mMcG",
  footer_button__cont: "FavourtiesModal-module_footer_button__cont__E2MtV",
  next_button: "FavourtiesModal-module_next_button__LlLFk",
  back_button: "FavourtiesModal-module_back_button__1PE19",
  not_now_button: "FavourtiesModal-module_not_now_button__lSloR",
  teams_skeleton__cont: "FavourtiesModal-module_teams_skeleton__cont__nV-du",
  team_skeleton__wrapper: "FavourtiesModal-module_team_skeleton__wrapper__inVXb"
};
W('.FavourtiesModal-module_PersonalizationModal__backdrop__6vewn {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: FavourtiesModal-module_enter__h-XuO 0.3s ease-in;\n  z-index: 5001;\n}\n@keyframes FavourtiesModal-module_enter__h-XuO {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.FavourtiesModal-module_PersonalizationModal__backdrop__6vewn.FavourtiesModal-module_will_hide__2443H {\n  animation: FavourtiesModal-module_exit__I7YSm 0.3s ease-in;\n}\n@keyframes FavourtiesModal-module_exit__I7YSm {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.FavourtiesModal-module_PersonalizationModal__cont__E1Zbb {\n  position: relative;\n  width: 100%;\n  max-width: 560px;\n  background: #06192f;\n  z-index: 5002;\n  border-radius: 16px;\n  animation: FavourtiesModal-module_enter__h-XuO 0.3s cubic-bezier(0.42, 1.13, 0.74, 1.13);\n}\n@keyframes FavourtiesModal-module_enter__h-XuO {\n  from {\n    margin-top: -200px;\n    opacity: 0;\n  }\n  to {\n    margin-top: 0px;\n    opacity: 1;\n  }\n}\n.FavourtiesModal-module_PersonalizationModal__cont__E1Zbb.FavourtiesModal-module_will_hide__2443H {\n  animation: FavourtiesModal-module_exit__I7YSm 0.3s cubic-bezier(0.42, 1.13, 0.74, 1.13);\n}\n@keyframes FavourtiesModal-module_exit__I7YSm {\n  from {\n    margin-top: 0px;\n    opacity: 1;\n  }\n  to {\n    margin-top: -200px;\n    opacity: 0;\n  }\n}\n.FavourtiesModal-module_PersonalizationModal__cont__E1Zbb.FavourtiesModal-module_phase-1__-YS-t::after {\n  content: "";\n  position: absolute;\n  background-color: white;\n  opacity: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  animation: FavourtiesModal-module_flash1__O80rj 0.2s ease-in;\n  z-index: -999;\n}\n@keyframes FavourtiesModal-module_flash1__O80rj {\n  from {\n    opacity: 1;\n    z-index: 999;\n  }\n  to {\n    opacity: 0;\n    z-index: -999;\n  }\n}\n.FavourtiesModal-module_PersonalizationModal__cont__E1Zbb.FavourtiesModal-module_phase-2__n5xEl::after {\n  content: "";\n  position: absolute;\n  background-color: white;\n  opacity: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  animation: FavourtiesModal-module_flash2__4lPfG 0.2s ease-in;\n  z-index: -999;\n}\n@keyframes FavourtiesModal-module_flash2__4lPfG {\n  from {\n    opacity: 1;\n    z-index: 999;\n  }\n  to {\n    opacity: 0;\n    z-index: -999;\n  }\n}\n.FavourtiesModal-module_PersonalizationModal__cont__E1Zbb.FavourtiesModal-module_phase-3__U6BfE::after {\n  content: "";\n  position: absolute;\n  background-color: white;\n  opacity: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  animation: FavourtiesModal-module_flash3__6x0Gs 0.2s ease-in;\n  z-index: -999;\n}\n@keyframes FavourtiesModal-module_flash3__6x0Gs {\n  from {\n    opacity: 1;\n    z-index: 999;\n  }\n  to {\n    opacity: 0;\n    z-index: -999;\n  }\n}\n\n.FavourtiesModal-module_close_icon__cont__3i0uN {\n  margin: 24px;\n  height: 20px;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.FavourtiesModal-module_close_icon__cont__3i0uN:hover {\n  cursor: pointer;\n}\n\n.FavourtiesModal-module_title__FOzRB {\n  font-family: "protipo-narrow";\n  font-weight: 500;\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 1;\n  margin-bottom: 24px;\n}\n.FavourtiesModal-module_title__FOzRB::before {\n  content: " ";\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 8px;\n  width: 24px;\n  height: 24px;\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20.25 6.75L9.75 17.25L4.5 12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\') no-repeat;\n}\n\n.FavourtiesModal-module_header_text__MfEtH {\n  color: white;\n  padding: 0;\n}\n.FavourtiesModal-module_header_text__MfEtH p:first-child {\n  margin-bottom: 16px;\n}\n.FavourtiesModal-module_header_text__MfEtH p {\n  font-family: "roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.FavourtiesModal-module_search__joaMN {\n  margin: 0 0 0 0;\n  padding: 12px 10px 12px 44px;\n  font-size: 16px;\n  line-height: 24px;\n  width: 100%;\n  color: #8e8e93;\n  font-family: roboto;\n  border: none;\n  border-radius: 4px;\n}\n\n.FavourtiesModal-module_header__cont__2xS60 {\n  padding: 24px 24px 0 24px;\n}\n.FavourtiesModal-module_header__cont__2xS60.FavourtiesModal-module_phase-3__U6BfE {\n  border-bottom: none;\n}\n@media (min-width: 768px) {\n  .FavourtiesModal-module_header__cont__2xS60 {\n    padding: 24px 24px 0 24px;\n  }\n}\n\n.FavourtiesModal-module_tabs__cont__oCwej {\n  margin: 24px 0 0 0;\n  max-height: 100px;\n  transition: max-height 0.4s ease-in-out;\n  overflow-x: auto;\n  overflow-y: hidden;\n  touch-action: pan-x;\n}\n.FavourtiesModal-module_tabs__cont__oCwej::-webkit-scrollbar {\n  background: transparent;\n  height: 1px;\n}\n.FavourtiesModal-module_tabs__cont__oCwej::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n.FavourtiesModal-module_tabs__cont__oCwej.FavourtiesModal-module_hidden__E0xdY {\n  max-height: 0px;\n}\n\n.FavourtiesModal-module_body__cont__sJzBy {\n  position: relative;\n  height: 348px;\n  overflow-y: scroll;\n  overflow-x: auto;\n  padding-bottom: 12px;\n}\n\n.FavourtiesModal-module_teams__cont__hbbZZ {\n  padding: 16px;\n}\n\n.FavourtiesModal-module_teams_wrapper__ZwjK2 {\n  margin: 0;\n  clear: both;\n}\n.FavourtiesModal-module_teams_wrapper__ZwjK2 h3 {\n  font-family: "protipo-narrow";\n  color: white;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: bold;\n  margin: 0 8px;\n}\n\n.FavourtiesModal-module_teams_heading__FvAP2 {\n  font-family: "protipo-narrow";\n  color: white;\n  font-size: 14px;\n  font-style: italic;\n  line-height: 16px;\n  margin: 0 8px;\n}\n\n.FavourtiesModal-module_team__cont__4DUWx {\n  border: 2px solid transparent;\n  display: inline-block;\n  position: relative;\n  border-radius: 8px;\n  text-align: center;\n  margin: 8px;\n  width: 100px;\n  height: fit-content;\n  min-height: 110px;\n  cursor: pointer;\n  background-color: #1d2f43;\n  transition: background-color 400ms, border 400ms;\n}\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_league__cont__-BcJN {\n  display: block;\n  width: calc(100% - 16px);\n  min-height: 24px;\n  padding: 16px;\n  text-align: left;\n}\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_league__cont__-BcJN .FavourtiesModal-module_team_logo__Ycf-7 {\n  height: 24px;\n}\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_league__cont__-BcJN .FavourtiesModal-module_team_name__52LhA {\n  margin: 0 0 0 8px !important;\n  line-height: 24px;\n}\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_league__cont__-BcJN .FavourtiesModal-module_team_logo__Ycf-7,\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_league__cont__-BcJN .FavourtiesModal-module_team_name__52LhA {\n  vertical-align: top;\n  margin: 0;\n  width: auto;\n  display: inline-block;\n}\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_league__cont__-BcJN::after {\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.FavourtiesModal-module_team__cont__4DUWx::after {\n  content: " ";\n  display: block;\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.275 11.9188L11.425 13.9188C11.8312 14.175 12.3312 13.7938 12.2125 13.325L11.3 9.73752C11.2753 9.63808 11.2792 9.53369 11.3113 9.43638C11.3434 9.33907 11.4023 9.2528 11.4812 9.18752L14.3062 6.83127C14.675 6.52502 14.4875 5.90627 14.0062 5.87502L10.3187 5.63752C10.2181 5.63166 10.1214 5.59663 10.0404 5.53669C9.95935 5.47675 9.89754 5.39451 9.8625 5.30002L8.4875 1.83752C8.4511 1.73745 8.38479 1.65102 8.29758 1.58994C8.21037 1.52886 8.10647 1.49609 8 1.49609C7.89352 1.49609 7.78963 1.52886 7.70241 1.58994C7.6152 1.65102 7.54889 1.73745 7.5125 1.83752L6.1375 5.30002C6.10245 5.39451 6.04064 5.47675 5.95962 5.53669C5.87859 5.59663 5.78186 5.63166 5.68125 5.63752L1.99375 5.87502C1.5125 5.90627 1.325 6.52502 1.69375 6.83127L4.51875 9.18752C4.59771 9.2528 4.65661 9.33907 4.68868 9.43638C4.72075 9.53369 4.72467 9.63808 4.7 9.73752L3.85625 13.0625C3.7125 13.625 4.3125 14.0813 4.79375 13.775L7.725 11.9188C7.8072 11.8665 7.90259 11.8387 8 11.8387C8.09741 11.8387 8.1928 11.8665 8.275 11.9188V11.9188Z" stroke="%23868E96" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n@media (min-width: 560px) {\n  .FavourtiesModal-module_team__cont__4DUWx {\n    width: calc(25% - 16px);\n  }\n}\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_selected__FCkp2 {\n  border: 2px solid white;\n}\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_selected__FCkp2::after {\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.55908 1.38516C7.68833 1.29465 7.84229 1.24609 8.00008 1.24609C8.15787 1.24609 8.31183 1.29465 8.44108 1.38516C8.56923 1.47491 8.66692 1.60161 8.72114 1.74829L10.097 5.21307C10.1152 5.26202 10.1472 5.30465 10.1891 5.3357C10.2311 5.36675 10.2812 5.3849 10.3334 5.38794L10.3349 5.38803L14.0224 5.62553C14.7416 5.67224 14.999 6.58075 14.4662 7.02343L11.6415 9.3795L11.6406 9.38018C11.598 9.41545 11.5662 9.46206 11.5488 9.51463C11.5316 9.56699 11.5294 9.62316 11.5426 9.6767L11.5427 9.67731L12.4549 13.2634C12.6246 13.9335 11.9041 14.5165 11.2917 14.1302L8.14108 12.1298C8.09898 12.103 8.04997 12.0887 8.00008 12.0887C7.95019 12.0887 7.90133 12.103 7.85923 12.1297L4.92805 13.9859C4.23842 14.4248 3.41969 13.7627 3.61402 13.001L4.45744 9.67731L4.45757 9.67676C4.47075 9.62321 4.46859 9.56702 4.45132 9.51463C4.434 9.46206 4.40218 9.41545 4.35952 9.38018L4.3587 9.3795L1.5341 7.02359C1.00139 6.5809 1.25839 5.67224 1.97763 5.62554L5.66681 5.38793C5.71893 5.3849 5.76905 5.36675 5.81102 5.3357C5.853 5.30465 5.88502 5.26204 5.90318 5.21309L5.90517 5.20772L7.27902 1.74829C7.33324 1.60161 7.43093 1.47491 7.55908 1.38516Z" fill="white"/></svg>\');\n}\n.FavourtiesModal-module_team__cont__4DUWx.FavourtiesModal-module_include_league__TgclW {\n  padding-bottom: 58px;\n}\n.FavourtiesModal-module_team__cont__4DUWx .FavourtiesModal-module_team_logo__Ycf-7 {\n  margin-top: 16px;\n  width: auto;\n  height: 40px;\n}\n.FavourtiesModal-module_team__cont__4DUWx .FavourtiesModal-module_team_name__52LhA {\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  font-family: "roboto", sans-serif;\n  text-transform: uppercase;\n  font-size: 12px;\n  color: white;\n  line-height: 14px;\n  transition: color 400ms;\n  margin-top: 12px;\n  margin-bottom: 16px;\n}\n.FavourtiesModal-module_team__cont__4DUWx .FavourtiesModal-module_team_league__u-Ues {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  bottom: 12px;\n  font-family: "urw-din", Helvetica, Arial, sans-serif;\n  text-transform: uppercase;\n  font-size: 12px;\n  color: #8e8e93;\n  line-height: 14px;\n  height: 14px;\n  transition: color 400ms;\n}\n\n.FavourtiesModal-module_location_instructions__cont__7uuAP {\n  font-family: "protipo-narrow";\n  margin-left: 8px;\n  margin-right: 8px;\n  margin-bottom: 24px;\n}\n.FavourtiesModal-module_location_instructions__cont__7uuAP h3 {\n  color: white;\n  margin: 0;\n  font-size: 14px;\n  font-style: italic;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n.FavourtiesModal-module_location_instructions__cont__7uuAP .FavourtiesModal-module_location_instructions__--mYu, .FavourtiesModal-module_location_instructions__cont__7uuAP .FavourtiesModal-module_location_instructions_ext__3C1yy {\n  font-family: "roboto", sans-serif;\n  position: relative;\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M16 17C18.2091 17 20 15.2091 20 13C20 10.7909 18.2091 9 16 9C13.7909 9 12 10.7909 12 13C12 15.2091 13.7909 17 16 17Z" stroke="%23ADB5BD" stroke-linecap="round" stroke-linejoin="round"/><path d="M26 13C26 22 16 29 16 29C16 29 6 22 6 13C6 10.3478 7.05357 7.8043 8.92893 5.92893C10.8043 4.05357 13.3478 3 16 3C18.6522 3 21.1957 4.05357 23.0711 5.92893C24.9464 7.8043 26 10.3478 26 13V13Z" stroke="%23ADB5BD" stroke-linecap="round" stroke-linejoin="round"/></svg>\') 11px center no-repeat;\n  background-color: #1d2f43;\n  border-radius: 8px;\n  padding: 22px 140px 24px 52px;\n  color: white;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.25;\n  display: block;\n}\n.FavourtiesModal-module_location_instructions__cont__7uuAP .FavourtiesModal-module_location_instructions__--mYu .FavourtiesModal-module_location_button__3ZwjT, .FavourtiesModal-module_location_instructions__cont__7uuAP .FavourtiesModal-module_location_instructions_ext__3C1yy .FavourtiesModal-module_location_button__3ZwjT {\n  display: inline-block;\n  padding: 9px 12px;\n  border-radius: 4px;\n  background-color: #005eb8;\n  color: white;\n  font-weight: bold;\n  line-height: 14px;\n  font-size: 14px;\n  font-weight: 500;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 16px;\n}\n.FavourtiesModal-module_location_instructions__cont__7uuAP .FavourtiesModal-module_location_instructions__--mYu .FavourtiesModal-module_location_button__3ZwjT:hover, .FavourtiesModal-module_location_instructions__cont__7uuAP .FavourtiesModal-module_location_instructions_ext__3C1yy .FavourtiesModal-module_location_button__3ZwjT:hover {\n  cursor: pointer;\n  opacity: 0.8;\n}\n.FavourtiesModal-module_location_instructions__cont__7uuAP .FavourtiesModal-module_location_instructions_ext__3C1yy {\n  padding: 22px 24px 24px 52px;\n}\n\n.FavourtiesModal-module_footer__cont__5jf7t {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1;\n  padding: 16px 24px;\n  box-shadow: 0px -3px 3px rgba(0, 0, 0, 0.0784313725);\n}\n@media (min-width: 768px) {\n  .FavourtiesModal-module_footer__cont__5jf7t {\n    flex-direction: row;\n    padding: 24px;\n  }\n}\n\n.FavourtiesModal-module_clean_footer__cont__xx-AR {\n  padding: 6px 24px 32px 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n@media (min-width: 768px) {\n  .FavourtiesModal-module_clean_footer__cont__xx-AR {\n    flex-direction: row-reverse;\n    justify-content: flex-start;\n    padding: 24px;\n  }\n}\n.FavourtiesModal-module_clean_footer__cont__xx-AR a {\n  text-decoration: none;\n}\n\n.FavourtiesModal-module_footer_title__KkCzw {\n  font-family: "urw-din", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  color: black;\n  font-weight: bold;\n  line-height: 22px;\n}\n\n.FavourtiesModal-module_footer_favorites__cont__uGUJn .FavourtiesModal-module_selected_favorite__QjcW6 {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n}\n.FavourtiesModal-module_footer_favorites__cont__uGUJn .FavourtiesModal-module_selected_favorite__QjcW6::after {\n  content: " ";\n  display: block;\n  width: 16px;\n  height: 16px;\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="%23DA291C"/><rect x="2.6665" y="7.11108" width="10.6667" height="1.77778" fill="white"/></svg>\') no-repeat;\n  position: absolute;\n  right: -5px;\n  top: -5px;\n}\n.FavourtiesModal-module_footer_favorites__cont__uGUJn .FavourtiesModal-module_selected_favorite__QjcW6 + .FavourtiesModal-module_selected_favorite__QjcW6 {\n  margin-left: 10px;\n}\n.FavourtiesModal-module_footer_favorites__cont__uGUJn .FavourtiesModal-module_team_logo__Ycf-7 {\n  display: block;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n}\n.FavourtiesModal-module_footer_favorites__cont__uGUJn .FavourtiesModal-module_none_selected__LElLu {\n  line-height: 32px;\n}\n.FavourtiesModal-module_footer_favorites__cont__uGUJn .FavourtiesModal-module_selected_favorites__cont__0mMcG {\n  font-family: "urw-din", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  color: #8e8e93;\n  line-height: 14px;\n}\n\n.FavourtiesModal-module_footer_button__cont__E2MtV {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.FavourtiesModal-module_next_button__LlLFk {\n  background: #005eb8;\n  color: white;\n  padding: 14px 16px;\n  font-family: "protipo-narrow";\n  font-size: 16px;\n  line-height: 16px;\n  border-radius: 4px;\n  width: 100%;\n  text-align: center;\n  margin-top: 16px;\n  transition: opacity 0.2s ease-in-out;\n}\n@media (min-width: 768px) {\n  .FavourtiesModal-module_next_button__LlLFk {\n    width: auto;\n    margin-top: 0;\n  }\n}\n.FavourtiesModal-module_next_button__LlLFk:hover {\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.FavourtiesModal-module_back_button__1PE19 {\n  border: 1px solid #d7e8f9;\n  background: transparent;\n  padding: 12px 14px;\n  border-radius: 4px;\n  color: #d7e8f9;\n  font-family: "protipo-narrow";\n  font-size: 16px;\n  line-height: 16px;\n  width: 100%;\n  text-align: center;\n  margin-top: 16px;\n  margin-right: 16px;\n  transition: opacity 0.2s ease-in-out;\n}\n@media (min-width: 768px) {\n  .FavourtiesModal-module_back_button__1PE19 {\n    width: auto;\n    margin-top: 0;\n  }\n}\n.FavourtiesModal-module_back_button__1PE19:hover {\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.FavourtiesModal-module_not_now_button__lSloR {\n  border: 1px solid #d7e8f9;\n  background: transparent;\n  padding: 12px 14px;\n  border-radius: 4px;\n  color: #d7e8f9;\n  font-family: "protipo-narrow";\n  font-size: 16px;\n  line-height: 16px;\n  width: 100%;\n  text-align: center;\n  margin-top: 16px;\n  transition: opacity 0.2s ease-in-out;\n}\n@media (min-width: 768px) {\n  .FavourtiesModal-module_not_now_button__lSloR {\n    width: auto;\n    margin-top: 0;\n    margin-right: 16px;\n  }\n}\n.FavourtiesModal-module_not_now_button__lSloR:hover {\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.FavourtiesModal-module_teams_skeleton__cont__nV-du .FavourtiesModal-module_team_skeleton__wrapper__inVXb {\n  display: inline-block;\n  margin: 8px;\n  width: calc(33.3333333333% - 16px);\n}\n@media (min-width: 360px) {\n  .FavourtiesModal-module_teams_skeleton__cont__nV-du .FavourtiesModal-module_team_skeleton__wrapper__inVXb {\n    width: calc(25% - 16px);\n  }\n}');
var q = function q() {
    return e.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("g", {
      id: "X"
    }, e.createElement("path", {
      id: "Vector",
      d: "M18.75 5.25L5.25 18.75",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), e.createElement("path", {
      id: "Vector_2",
      d: "M18.75 18.75L5.25 5.25",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })));
  },
  B = {
    LoadingSkeleton__cont: "LoadingSkeleton-module_LoadingSkeleton__cont__voTNN",
    LoadingSkeleton__animated: "LoadingSkeleton-module_LoadingSkeleton__animated__wxmIl",
    shine: "LoadingSkeleton-module_shine__x0Cxs",
    grey: "LoadingSkeleton-module_grey__0i2c3",
    snBlue: "LoadingSkeleton-module_snBlue__Rn0Ew"
  };
function $() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return t.filter(Boolean).join(" ");
}
W(".LoadingSkeleton-module_LoadingSkeleton__cont__voTNN {\n    background-color: #ddd;\n}\n\n.LoadingSkeleton-module_LoadingSkeleton__animated__wxmIl {\n    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n    border-radius: 5px;\n    background-size: 400% 100%;\n    animation-name: LoadingSkeleton-module_shine__x0Cxs;\n    animation-duration: 3s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n\n    &.LoadingSkeleton-module_grey__0i2c3 {\n        background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n        background-size: 400% 100%;\n    }\n    &.LoadingSkeleton-module_snBlue__Rn0Ew {\n        background: linear-gradient(110deg, #156bac 8%, #156bac99 18%, #156bac 33%);\n        background-size: 400% 100%;\n    }\n}\n\n@keyframes LoadingSkeleton-module_shine__x0Cxs {\n    to {\n        background-position-x: -400%;\n    }\n}\n");
var V = function V(t) {
  var n = t.width,
    o = t.height,
    r = t.aspectRatio,
    a = t.opacity,
    i = t.round,
    l = t.animate,
    s = t.borderRadius,
    c = t.marginTop,
    u = t.color;
  return e.createElement("div", {
    className: $(B.LoadingSkeleton__cont, l ? B.LoadingSkeleton__animated : "", B[u]),
    style: {
      width: n,
      height: o,
      aspectRatio: r,
      marginTop: c,
      opacity: a,
      borderRadius: i ? "50%" : s
    }
  });
};
V.propTypes = {
  width: R.oneOfType([R.number, R.string]),
  height: R.oneOfType([R.number, R.string]),
  round: R.bool,
  animate: R.bool,
  borderRadius: R.number,
  color: R.oneOf(["grey", "snBlue"])
}, V.defaultProps = {
  width: 32,
  height: 12,
  round: !1,
  animate: !0,
  borderRadius: 0,
  color: "grey"
};
var D = function D(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    return {
      id: e.id,
      name: e.name,
      league: n ? t : null,
      logoUrl: e.img_url || e.icon
    };
  },
  J = function J(t) {
    var n = t.selectionPhase,
      o = t.searchResults,
      r = t.selectedTeams,
      a = t.handleTeamClick,
      i = t.handleLeagueClick,
      l = t.showNearbyTeams,
      s = t.nearbyTeamsToShow,
      c = t.defaultNearbyTeamsToShow,
      u = t.teamsToShow,
      d = t.leaguesToShow,
      _ = t.loadNearbyTeams,
      m = t.isLoading,
      f = t.locationError,
      p = t.leagueToShow;
    return m ? e.createElement("div", {
      className: Y.teams_skeleton__cont
    }, e.createElement("div", {
      className: Y.team_skeleton__wrapper
    }, e.createElement(V, {
      width: "100%",
      height: 130,
      borderRadius: 4
    })), e.createElement("div", {
      className: Y.team_skeleton__wrapper
    }, e.createElement(V, {
      width: "100%",
      height: 130,
      borderRadius: 4
    })), e.createElement("div", {
      className: Y.team_skeleton__wrapper
    }, e.createElement(V, {
      width: "100%",
      height: 130,
      borderRadius: 4
    }))) : 1 === n && o ? e.createElement("div", {
      className: "test"
    }, e.createElement(G, {
      teams: o,
      selectedTeams: r,
      handleTeamClick: a,
      handleLeagueClick: i
    })) : 1 === n && l ? e.createElement(e.Fragment, null, !(null != s && s.length) && e.createElement("div", {
      className: Y.location_instructions__cont
    }, navigator.geolocation && !f && e.createElement(e.Fragment, null, e.createElement("h3", null, "LOCAL TEAMS"), e.createElement("div", {
      className: Y.location_instructions
    }, "Share your location to see nearby teams", e.createElement("span", {
      className: Y.location_button,
      onClick: _
    }, "Share location"))), f && e.createElement("div", {
      className: Y.location_instructions_ext
    }, "Unable to access your location. Please enable location services in your browser settings."), !navigator.geolocation && e.createElement("div", {
      className: Y.location_instructions
    }, "Your browser does not support location services")), s.length > 0 ? e.createElement("div", {
      className: Y.teams_wrapper
    }, e.createElement("h3", null, "LOCAL TEAMS"), e.createElement(G, {
      teams: s,
      selectedTeams: r,
      handleTeamClick: a
    })) : "", e.createElement("div", {
      className: Y.teams_wrapper
    }, e.createElement("h3", null, "POPULAR TEAMS"), e.createElement(G, {
      teams: c,
      selectedTeams: r,
      handleTeamClick: a
    }))) : 1 !== n || l || o ? 2 !== n || o ? 2 === n && o ? e.createElement(G, {
      teams: o,
      selectedTeams: r,
      handleTeamClick: a
    }) : void 0 : e.createElement(G, {
      teams: d,
      selectedTeams: r,
      handleTeamClick: a
    }) : e.createElement(e.Fragment, null, e.createElement("h3", {
      className: "".concat(Y.teams_heading)
    }, "League"), e.createElement(Z, {
      league: p,
      selectedTeams: r,
      handleLeagueClick: i
    }), u.length > 0 ? e.createElement("h3", {
      className: "".concat(Y.teams_heading)
    }, "Teams") : e.createElement(e.Fragment, null), e.createElement(G, {
      teams: u,
      selectedTeams: r,
      handleTeamClick: a
    }));
  },
  G = function G(t) {
    var n = t.teams,
      o = t.selectedTeams,
      r = t.handleTeamClick;
    return n.map(function (t) {
      var n = !!o.find(function (e) {
          return e.id === t.id;
        }),
        a = !!t.league,
        i = D(t);
      return e.createElement("div", {
        className: "\n                    ".concat(Y.team__cont, " \n                    ").concat(n ? Y.selected : "", "\n                    ").concat(a ? Y.include_league : "", "\n                "),
        key: i.id,
        onClick: function onClick() {
          return r(t);
        }
      }, e.createElement("img", {
        className: Y.team_logo,
        src: i.logoUrl
      }), e.createElement("div", {
        className: "".concat(Y.team_name, " ").concat(n ? Y.selected : "")
      }, i.name), a && e.createElement("div", {
        className: "".concat(Y.team_league, " ").concat(n ? Y.selected : "")
      }, i.league));
    });
  },
  Z = function Z(t) {
    var n = t.league,
      o = t.selectedTeams,
      r = t.handleLeagueClick,
      a = o.length > 0 && o.filter(function (e) {
        return e.slug === n.slug;
      }),
      i = D(n);
    return e.createElement("div", {
      className: "\n                    ".concat(Y.team__cont, " ").concat(Y.league__cont, " ").concat(a[0] ? Y.selected : "", "\n                "),
      key: i.id,
      onClick: function onClick() {
        return r(n);
      }
    }, e.createElement("img", {
      className: Y.team_logo,
      src: i.logoUrl
    }), e.createElement("div", {
      className: "".concat(Y.team_name)
    }, i.name));
  },
  H = {
    tabs__wrapper: "Tabs-module_tabs__wrapper__gg81P",
    tabs__cont: "Tabs-module_tabs__cont__qW1gu",
    oval: "Tabs-module_oval__J4P-b",
    tab: "Tabs-module_tab__LYqhc",
    selected: "Tabs-module_selected__ToUV8",
    modern: "Tabs-module_modern__Ajb47",
    arrow: "Tabs-module_arrow__7j-oT",
    retro: "Tabs-module_retro__jIY-R"
  };
W('.Tabs-module_tabs__wrapper__gg81P {\n  display: block;\n}\n\n.Tabs-module_tabs__cont__qW1gu {\n  display: inline-flex;\n  flex-direction: row;\n  padding-right: 24px;\n  overflow: scroll;\n  width: 100%;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n.Tabs-module_tabs__cont__qW1gu.Tabs-module_oval__J4P-b {\n  background: #e9ecef;\n  border-radius: 30px;\n  padding-right: 0;\n  padding: 2px;\n}\n.Tabs-module_tabs__cont__qW1gu::-webkit-scrollbar {\n  display: none;\n}\n\n.Tabs-module_tab__LYqhc {\n  font-family: "protipo-narrow";\n  position: relative;\n  margin-left: 24px;\n  font-size: 15px;\n  padding-bottom: 4px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.Tabs-module_tab__LYqhc:first-of-type {\n  margin-left: 0px;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_oval__J4P-b {\n  font-size: 12px;\n  width: 189px;\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  margin-left: 0;\n  transition: 0.3s cubic-bezier(0.1, 0.29, 0.76, 1.5);\n}\n.Tabs-module_tab__LYqhc.Tabs-module_oval__J4P-b.Tabs-module_selected__ToUV8 {\n  border-bottom-width: 0;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47 {\n  font-size: 14px;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47:hover {\n  color: #005eb8;\n  border-bottom: 2px solid #005eb8;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n  border-bottom-width: 4px;\n  text-shadow: 1px 0px 0px #002b49;\n}\n.Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 .Tabs-module_arrow__7j-oT {\n  position: absolute;\n  left: calc(50% - 3px);\n  bottom: -7px;\n  box-sizing: content-box;\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  rotate: 270deg;\n}\n\n@media (prefers-color-scheme: dark) {\n  .Tabs-module_tabs__wrapper__gg81P {\n    color: #fff;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n    color: #fff;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47.Tabs-module_selected__ToUV8 {\n    border-bottom: 2px solid #005eb8 !important;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_retro__jIY-R.Tabs-module_selected__ToUV8 {\n    color: #fff;\n    border-bottom: 4px solid #fff;\n  }\n  .Tabs-module_tabs__cont__qW1gu {\n    color: #fff;\n    border-bottom-color: #005eb8;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_oval__J4P-b {\n    color: #0b223e;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 {\n    border-bottom: 1px solid #adb5bd;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 .Tabs-module_arrow__7j-oT {\n    border-left: 7px solid #005eb8;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_retro__jIY-R {\n    border-bottom: 1px solid #495057;\n    color: rgb(206, 212, 218);\n  }\n}\n.darkMode .Tabs-module_tabs__wrapper__gg81P {\n  color: #fff;\n}\n.darkMode .Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n  color: #fff;\n}\n.darkMode .Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47.Tabs-module_selected__ToUV8 {\n  border-bottom: 2px solid #005eb8 !important;\n}\n.darkMode .Tabs-module_tab__LYqhc.Tabs-module_retro__jIY-R.Tabs-module_selected__ToUV8 {\n  color: #fff;\n  border-bottom: 4px solid #fff;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu {\n  color: #fff;\n  border-bottom-color: #005eb8;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_oval__J4P-b {\n  color: #0b223e;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 {\n  border-bottom: 1px solid #adb5bd;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 .Tabs-module_arrow__7j-oT {\n  border-left: 7px solid #005eb8;\n}\n.darkMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_retro__jIY-R {\n  border-bottom: 1px solid #495057;\n  color: rgb(206, 212, 218);\n}\n\n@media (prefers-color-scheme: light) {\n  .Tabs-module_tabs__wrapper__gg81P {\n    color: #000;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n    color: #0b223e;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_retro__jIY-R.Tabs-module_selected__ToUV8 {\n    color: #005eb8;\n    border-bottom: 4px solid #005eb8;\n  }\n  .Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47.Tabs-module_selected__ToUV8 {\n    color: #002b49;\n    border-bottom: 2px solid #002b49 !important;\n  }\n  .Tabs-module_tabs__cont__qW1gu {\n    color: #002b49;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 {\n    border-bottom: 1px solid #d6dade;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 .Tabs-module_arrow__7j-oT {\n    border-left: 7px solid #002b49;\n  }\n  .Tabs-module_tabs__cont__qW1gu.Tabs-module_retro__jIY-R {\n    color: #002b49;\n    border-bottom: 1px solid #d6dade;\n  }\n}\n.lightMode .Tabs-module_tabs__wrapper__gg81P {\n  color: #000;\n}\n.lightMode .Tabs-module_tab__LYqhc.Tabs-module_selected__ToUV8 {\n  color: #0b223e;\n}\n.lightMode .Tabs-module_tab__LYqhc.Tabs-module_retro__jIY-R.Tabs-module_selected__ToUV8 {\n  color: #005eb8;\n  border-bottom: 4px solid #005eb8;\n}\n.lightMode .Tabs-module_tab__LYqhc.Tabs-module_modern__Ajb47.Tabs-module_selected__ToUV8 {\n  color: #002b49;\n  border-bottom: 2px solid #002b49 !important;\n}\n.lightMode .Tabs-module_tabs__cont__qW1gu {\n  color: #002b49;\n}\n.lightMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 {\n  border-bottom: 1px solid #d6dade;\n}\n.lightMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_modern__Ajb47 .Tabs-module_arrow__7j-oT {\n  border-left: 7px solid #002b49;\n}\n.lightMode .Tabs-module_tabs__cont__qW1gu.Tabs-module_retro__jIY-R {\n  color: #002b49;\n  border-bottom: 1px solid #d6dade;\n}');
var X = function X(r) {
  var a,
    i,
    l = r.tabs,
    s = r.spaceAboveTabs,
    u = r.spaceAboveTabsMobile,
    _ = r.spaceBelowTabs,
    m = r.spaceBelowTabsMobile,
    f = r.selectedTabIndexOverride,
    p = r.underlineWidth,
    b = r.tabHeight,
    h = r.paddingLeft,
    v = r.tabType,
    g = r.activeBgTabColor,
    y = r.forceColorScheme,
    x = r.justifyContent,
    w = r.hideBottomBorder,
    M = r.hideTabList,
    T = function () {
      var e = "undefined" != typeof window;
      function o() {
        return {
          windowWidth: e ? window.innerWidth : null,
          windowHeight: e ? window.innerHeight : null
        };
      }
      var r = d(t(o()), 2),
        a = r[0],
        i = r[1];
      return n(function () {
        if (e) {
          var t = function t() {
            i(o());
          };
          return window.addEventListener("resize", t), function () {
            return window.removeEventListener("resize", t);
          };
        }
      }, [e]), a;
    }(),
    k = T.windowWidth < 768,
    F = o({});
  v = null === (a = v) || void 0 === a ? void 0 : a.toLowerCase();
  var E = d(t(f || 0), 2),
    C = E[0],
    L = E[1],
    j = d(t(C), 2),
    S = j[0],
    N = j[1];
  n(function () {
    f && L(f);
  }, [f]);
  var O = function O(e) {
      var t = F.current[e];
      t && (N(e), t.focus());
    },
    P = function P(e) {
      var t = l.length,
        n = function n() {
          return F.current[S].click();
        },
        o = {
          ArrowRight: function ArrowRight() {
            return O((S + 1) % t);
          },
          ArrowLeft: function ArrowLeft() {
            return O((S - 1 + t) % t);
          },
          Home: function Home() {
            return O(0);
          },
          End: function End() {
            return O(t - 1);
          },
          Enter: n,
          " ": n
        }[e.key];
      o && (e.preventDefault(), o());
    };
  return e.createElement("div", {
    className: $(H.tabs__wrapper, y)
  }, !M && e.createElement("div", {
    role: "tablist",
    "aria-label": "Tab List",
    "aria-orientation": "horizontal",
    className: "".concat(H.tabs__cont, " ").concat(H[v]),
    style: c({
      marginTop: k ? u : s,
      marginBottom: k ? m : _,
      paddingLeft: h,
      justifyContent: x
    }, w && {
      borderBottom: "none"
    })
  }, l.map(function (t, n) {
    var o = n === C ? H.selected : "",
      r = {
        borderBottomWidth: p,
        height: b,
        background: n === C && g
      };
    return e.createElement("div", {
      key: "tab-".concat(n),
      role: "tab",
      "aria-selected": n === C,
      "aria-controls": "panel-id-".concat(n),
      id: "tab-id-".concat(n),
      ref: function ref(e) {
        return F.current[n] = e;
      },
      tabIndex: n === C ? 0 : -1,
      className: "".concat(H.tab, " ").concat(o, " ").concat(H[v]),
      style: r,
      onClick: function onClick() {
        return function (e, t) {
          L(t), e.onClick && e.onClick(), N(t);
        }(t, n);
      },
      onKeyDown: P
    }, t.displayName, "modern" === v && e.createElement("div", {
      className: H.arrow
    }));
  })), e.createElement("div", {
    key: "tabpanel-".concat(C),
    id: "panel-id-".concat(C),
    role: "tabpanel",
    "aria-labelledby": "tab-id".concat(C),
    tabIndex: 0
  }, null === (i = l[C]) || void 0 === i ? void 0 : i.content));
};
X.propTypes = {
  forceColorScheme: R.oneOf(["darkMode", "lightMode", "system"]).isRequired,
  tabs: R.arrayOf(R.shape({
    id: R.string.isRequired,
    displayName: R.string.isRequired
  })),
  spaceAboveTabs: R.number,
  spaceAboveTabsMobile: R.number,
  spaceBelowTabs: R.number,
  spaceBelowTabsMobile: R.number,
  selectedTabIndexOverride: R.number,
  underlineWidth: R.number,
  tabHeight: R.number,
  paddingLeft: R.number,
  tabType: R.oneOf(["retro", "modern", "oval"]),
  activeBgTabColor: R.string,
  justifyContent: R.oneOf(["left", "center", "right"]),
  hideBottomBorder: R.bool,
  hideTabList: R.bool
}, X.defaultProps = {
  tabs: [],
  tabType: "retro",
  forceColorScheme: "lightMode",
  justifyContent: "left",
  hideBottomBorder: !1,
  hideTabList: !1
};
var K = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg id='MagnifyingGlass'%3e%3cpath id='Vector' d='M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath id='Vector_2' d='M16.4438 16.4438L21.0001 21' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  Q = function Q(o) {
    var r = o.userUUID,
      a = o.apiToken,
      l = o.onClickDone,
      s = o.onModalClose,
      c = o.show,
      m = void 0 !== c && c,
      f = o.accountCreationUrl,
      p = o.apiUrl,
      b = void 0 === p ? "https://int-stats.sportsnet.ca/kremer" : p,
      h = d(t(m), 2),
      v = h[0],
      g = h[1],
      y = d(t(!1), 2),
      x = y[0],
      w = y[1],
      M = d(t(!0), 2),
      T = M[0],
      k = M[1],
      F = d(t([{
        id: "nearby",
        displayName: "Suggested",
        onClick: function onClick() {
          S(!0);
        }
      }]), 2),
      E = F[0],
      C = F[1],
      L = d(t(!0), 2),
      j = L[0],
      S = L[1],
      N = d(t(!1), 2),
      O = N[0],
      P = N[1],
      A = d(t([]), 2),
      z = A[0],
      U = A[1],
      I = d(t([]), 2),
      R = I[0],
      W = I[1],
      B = d(t([]), 2),
      $ = B[0],
      V = B[1],
      D = d(t([]), 2),
      G = D[0],
      Z = D[1],
      H = d(t(null), 2),
      Q = H[0],
      ee = H[1],
      te = d(t([]), 2),
      ne = te[0],
      oe = te[1],
      re = d(t([]), 2),
      ae = re[0],
      ie = re[1],
      le = d(t(""), 2),
      se = le[0],
      ce = le[1],
      ue = d(t([]), 2),
      de = ue[0],
      _e = ue[1],
      me = d(t([]), 2),
      fe = me[0],
      pe = me[1],
      be = d(t(1), 2),
      he = be[0],
      ve = be[1],
      ge = d(t(!1), 2),
      ye = ge[0],
      xe = ge[1],
      we = !r || f,
      Me = function Me(e) {
        ee(null), P(!1), ce(""), ve(e);
      },
      Te = function Te(e) {
        var t = de.findIndex(function (t) {
            return t.id === e.id;
          }),
          n = de;
        n = t >= 0 ? de.filter(function (t) {
          return t.id !== e.id;
        }) : [].concat(_(de), [e]), _e(n), ke(n);
      },
      ke = function () {
        var e = i(u().mark(function e(t) {
          var n;
          return u().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (localStorage.setItem("favourites", JSON.stringify(t)), a && r) {
                  e.next = 3;
                  break;
                }
                return e.abrupt("return");
              case 3:
                return e.next = 5, fetch("".concat(b, "/preferences"), {
                  method: "POST",
                  headers: {
                    Authorization: "Bearer ".concat(a),
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    guid: r,
                    stats_ids: t.map(function (e) {
                      return e.stats_id;
                    })
                  })
                });
              case 5:
                return n = e.sent, e.next = 8, n.json();
              case 8:
                !0 === e.sent.success && localStorage.setItem("APIsaved", !0);
              case 10:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }(),
      Fe = function Fe(e) {
        var t = ["nhl.4974", "nhl.4963", "nhl.4983", "nhl.4981", "nhl.4956", "nhl.4959", "nhl.4975", "mlb.238", "nba.28"],
          n = [];
        for (var o in e) {
          if (e[o].length > 0) e[o].filter(function (e) {
            t.includes(e.stats_id) && n.push(e);
          });
        }
        V(n);
      },
      Ee = function () {
        var e = i(u().mark(function e() {
          var t;
          return u().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return k(!0), e.next = 3, Ce();
              case 3:
                (t = e.sent).length > 0 ? W(t) : Fe(ne), S(!0), k(!1);
              case 7:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }(),
      Ce = function () {
        var e = i(u().mark(function e() {
          var t, n, o, r, a, i;
          return u().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return xe(!1), t = function t() {
                  return new Promise(function (e, t) {
                    navigator.geolocation.getCurrentPosition(e, t);
                  });
                }, e.next = 4, t().catch(function () {
                  xe(!0);
                });
              case 4:
                if (!(n = e.sent)) {
                  e.next = 19;
                  break;
                }
                return o = n.coords.latitude, r = n.coords.longitude, e.next = 10, fetch("".concat(b, "/localteams?lat=").concat(o, "&long=").concat(r));
              case 10:
                if (200 !== (a = e.sent).status) {
                  e.next = 18;
                  break;
                }
                return e.next = 14, a.json();
              case 14:
                return i = e.sent, e.abrupt("return", (null == i ? void 0 : i.teams) || []);
              case 18:
                xe(!0);
              case 19:
                return e.abrupt("return", []);
              case 20:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }(),
      Le = function Le() {
        w(!0), setTimeout(function () {
          g(!1), s && s();
        }, 300);
      },
      je = function je(e, t) {
        t.forEach(function (t) {
          t.slug === e.toLowerCase() && pe(t);
        });
      },
      Se = function () {
        var e = i(u().mark(function e() {
          var t, n, o, i, l, s, c, d, m, f, p, h, v, g, y, x, w, M;
          return u().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (k(!0), i = [], l = JSON.parse(localStorage.getItem("favourites")) || [], i.push.apply(i, _(l)), !a || !r) {
                  e.next = 12;
                  break;
                }
                return e.next = 7, fetch("".concat(b, "/preferences"), {
                  headers: {
                    Authorization: "Bearer ".concat(a)
                  }
                });
              case 7:
                return s = e.sent, e.next = 10, s.json();
              case 10:
                (c = e.sent).selected && i.push.apply(i, _(c.selected));
              case 12:
                return d = new Set(), m = i.filter(function (e) {
                  var t = d.has(e.id);
                  return d.add(e.id), !t;
                }), _e(m), e.next = 17, fetch("".concat(b, "/options"));
              case 17:
                return f = e.sent, e.next = 20, f.json();
              case 20:
                p = e.sent, h = (null == p || null === (t = p.available) || void 0 === t ? void 0 : t.teams) || {}, v = [], g = (null == p || null === (n = p.available) || void 0 === n ? void 0 : n["sports-leagues"]) || [], y = u().mark(function e(t) {
                  var n;
                  return u().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        n = h[t], v.push({
                          id: t,
                          displayName: t,
                          key: t.toLowerCase,
                          onClick: function onClick() {
                            S(!1), U(n), je(t, g);
                          }
                        });
                      case 2:
                      case "end":
                        return e.stop();
                    }
                  }, e);
                }), e.t0 = u().keys(h);
              case 26:
                if ((e.t1 = e.t0()).done) {
                  e.next = 31;
                  break;
                }
                return x = e.t1.value, e.delegateYield(y(x), "t2", 29);
              case 29:
                e.next = 26;
                break;
              case 31:
                return C(function (e) {
                  return [].concat(_(e), v);
                }), oe(h), ie(g), Z(g), e.next = 37, null === (o = navigator) || void 0 === o || null === (o = o.permissions) || void 0 === o ? void 0 : o.query({
                  name: "geolocation"
                });
              case 37:
                if (w = e.sent, !("granted" === (null == w ? void 0 : w.state))) {
                  e.next = 44;
                  break;
                }
                return e.next = 42, Ce();
              case 42:
                (M = e.sent).length > 0 && W(M);
              case 44:
                Fe(h), k(!1);
              case 46:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }();
    return n(function () {
      m ? (ve(1), Se(), w(!1), g(m)) : v && Le();
    }, [m]), v ? e.createElement("div", {
      className: "".concat(Y.PersonalizationModal__backdrop, " ").concat(x ? Y.will_hide : ""),
      onClick: function onClick() {
        return Le();
      }
    }, e.createElement("div", {
      className: "\n                    ".concat(Y.PersonalizationModal__cont, "  \n                    ").concat(Y["phase-" + he], "\n                    ").concat(x ? Y.will_hide : "", "\n                "),
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, e.createElement("div", {
      className: "".concat(Y.header__cont, " ").concat(Y["phase-".concat(he)])
    }, e.createElement("div", {
      className: Y.close_icon__cont,
      onClick: function onClick() {
        return Le();
      }
    }, e.createElement(q, null)), 1 === he && e.createElement(e.Fragment, null, e.createElement("div", {
      className: Y.title
    }, "Add Favourites")), 2 === he && e.createElement(e.Fragment, null, e.createElement("div", {
      className: Y.title
    }, "Select your favourite leagues & sports")), 3 === he && we && e.createElement(e.Fragment, null, e.createElement("div", {
      className: Y.title
    }, "Favourites saved"), e.createElement("div", {
      className: Y.header_text
    }, e.createElement("p", null, "Your favourites have been saved to this device."), e.createElement("p", null, "Create an account to have your preferences applied on all Sportsnet apps and websites."))), 3 === he && !we && e.createElement(e.Fragment, null, e.createElement("div", {
      className: Y.title
    }, "Favourites saved"), e.createElement("div", {
      className: Y.header_text
    }, "Update your selections any time from the My Favourites section, of from your profile.")), (1 === he || 2 === he) && e.createElement("div", {
      className: Y.search__cont
    }, 1 === he && e.createElement("input", {
      className: Y.search,
      style: {
        background: "url(".concat(K, ") no-repeat 12px center rgba(255, 255, 255, 0.10)")
      },
      type: "text",
      placeholder: "Search for a team or league",
      name: "search",
      value: se,
      onChange: function onChange(e) {
        return function (e) {
          if (ce(e), e.length > 0) {
            P(!0);
            var t = [];
            for (var n in ne) {
              var o = ne[n].filter(function (t) {
                return t.name.toLowerCase().includes(e.toLowerCase()) || t.display_name.toLowerCase().includes(e.toLowerCase()) || t.city.toLowerCase().includes(e.toLowerCase()) || t.alias.toLowerCase().includes(e.toLowerCase());
              });
              t.push.apply(t, _(o));
            }
            var r = ae.filter(function (t) {
              return t.name.toLowerCase().includes(e.toLowerCase()) || t.display_name.toLowerCase().includes(e.toLowerCase()) || t.sport_slug.toLowerCase().includes(e.toLowerCase()) || t.title.toLowerCase().includes(e.toLowerCase());
            });
            t.push.apply(t, _(r)), ee(t);
          } else P(!1), ee(null);
        }(e.target.value);
      }
    }), 2 === he && e.createElement("input", {
      className: Y.search,
      style: {
        background: "url(".concat(K, ") no-repeat 12px center rgba(255, 255, 255, 0.10)")
      },
      type: "text",
      placeholder: "Search",
      name: "search",
      value: se,
      onChange: function onChange(e) {
        return function (e) {
          if (ce(e), e.length > 0) {
            var t = ae.filter(function (t) {
              return t.name.toLowerCase().includes(e.toLowerCase()) || t.display_name.toLowerCase().includes(e.toLowerCase()) || t.sport_slug.toLowerCase().includes(e.toLowerCase()) || t.title.toLowerCase().includes(e.toLowerCase());
            });
            ee(t);
          } else ee(null);
        }(e.target.value);
      }
    }))), 1 === he && e.createElement("div", {
      className: "".concat(Y.tabs__cont, " ").concat(O ? Y.hidden : "")
    }, e.createElement(X, {
      tabs: E,
      underlineWidth: 4,
      tabHeight: 30,
      paddingLeft: 24,
      paddingRight: 24,
      spaceBelowTabs: 10,
      forceColorScheme: "darkMode"
    })), (1 === he || 2 === he) && e.createElement("div", {
      className: "".concat(Y.body__cont)
    }, e.createElement("div", {
      className: Y.teams__cont
    }, e.createElement(J, {
      isLoading: T,
      selectionPhase: he,
      searchResults: Q,
      selectedTeams: de,
      handleTeamClick: Te,
      handleLeagueClick: function handleLeagueClick(e) {
        var t = de.findIndex(function (t) {
            return t.slug === e.slug;
          }),
          n = de;
        n = t >= 0 ? de.filter(function (t) {
          return t.id !== e.id;
        }) : [].concat(_(de), [e]), _e(n), ke(n);
      },
      showNearbyTeams: j,
      nearbyTeamsToShow: R,
      defaultNearbyTeamsToShow: $,
      teamsToShow: z,
      leaguesToShow: G,
      leagueToShow: fe,
      loadNearbyTeams: Ee,
      locationError: ye
    }))), (1 === he || 2 === he) && e.createElement("div", {
      className: Y.footer__cont
    }, e.createElement("div", {
      className: Y.footer_favorites__cont
    }, e.createElement("div", {
      className: Y.footer_title
    }), e.createElement("div", {
      className: Y.selected_favorites__cont
    }, !!de.length && de.map(function (t) {
      var n = function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return {
          id: e.id,
          name: e.name,
          league: n ? t : null,
          logoUrl: e.img_url || e.icon
        };
      }(t);
      return e.createElement("div", {
        key: n.id,
        className: Y.selected_favorite,
        onClick: function onClick() {
          return Te(t);
        }
      }, e.createElement("img", {
        className: Y.team_logo,
        src: n.logoUrl,
        alt: "team logo"
      }));
    }), !de.length && e.createElement("div", {
      className: Y.none_selected
    }))), e.createElement("div", {
      className: Y.footer_button__cont
    }, 1 === he && e.createElement("div", {
      className: Y.next_button,
      onClick: function onClick() {
        return Me(3);
      }
    }, "Continue"), 2 === he && e.createElement(e.Fragment, null, e.createElement("div", {
      className: Y.back_button,
      onClick: function onClick() {
        return Me(1);
      }
    }, "Back"), e.createElement("div", {
      className: Y.next_button,
      onClick: function onClick() {
        l && l(), Me(3);
      }
    }, "Continue")))), 3 === he && we && e.createElement("div", {
      className: Y.clean_footer__cont
    }, e.createElement("a", {
      className: Y.next_button,
      href: f
    }, "Create an account"), e.createElement("div", {
      className: Y.not_now_button,
      onClick: Le
    }, "Maybe later")), 3 === he && !we && e.createElement("div", {
      className: Y.clean_footer__cont
    }, e.createElement("div", {
      className: Y.next_button,
      onClick: Le
    }, "Okay")))) : null;
  };
Q.propTypes = {
  userUUID: R.string,
  apiToken: R.string,
  onClickDone: R.func,
  onModalClose: R.func,
  show: R.bool,
  accountCreationUrl: R.string,
  apiUrl: R.string
}, Q.defaultProps = {
  show: !1,
  apiUrl: "https://int-stats.sportsnet.ca/kremer",
  onModalClose: function onModalClose() {}
};
export { Q as FavouritesModal, Q as default };